import { botResponseMessageParser } from '@/services/parser/botResponseParser'
import cloneDeep from 'lodash/cloneDeep'
import store from '../store'
import Storage from '@/services/storageLib'
import { clearAllSetTimeout } from '@/services/utils'
import CONSTANTS from '@/services/constants/constantStrings'
import { getDataInChunks, hideMessage } from '@/services/utils'
import { emitEventToParentWindow } from './utils'
import { eventType } from './constants'
import { componentMapper } from '@/services/constants'
import { v4 as uuidV4 } from 'uuid'
import TextAccumulatorUtil from './textAccumulator'
class StreamHandler {
  constructor() {
    this.chunksArray = []
    this.currentProcessingRequiredIndex = 0
    this.success = false
    this.timerIds = []
    this.chunkQueue = []
    this.chunkLength = 3
    this.totalChunks = 0
    this.lastChunkProcessed = null
    this.startNewMessage = false
    this.audioAttachment = ''
    this.fillerTextIndex = 0
  }

  init(disableInputFieldOnSendMessage) {
    this.endChunkProcessing(disableInputFieldOnSendMessage)
  }

  addAndProcessChunks(data) {
    const formComponentType = data?.attachments?.[0] && componentMapper[data.attachments[0]?.type]?.[0];
    if (formComponentType === 'FillerText') {
      // console.log("Filler" , JSON.parse(JSON.stringify(data)))
      const fillerText = data?.attachments?.[0]?.attachment?.text
      let progressiveTypingIndicatorConfig = cloneDeep(store.getters.getProgressiveTypingIndicatorConfig)
      progressiveTypingIndicatorConfig = [{
        duration: 200000,
        text: fillerText
      }]
      store.commit("UPDATE_PROGRESSIVE_TYPING_INDICATOR_CONFIG" , progressiveTypingIndicatorConfig)
      this.fillerTextIndex++
      return;
    }
    if(data.attachments.length === 0 && (data.customPayload?.CHUNK_INDEX - this.fillerTextIndex === 0)) {
      this.fillerTextIndex++;
      return;
    }
    const messageKeyForLocalStorage = store.getters.isResponseAnalyzerEnabled ? 'responseAnalyzerMessageId' : 'currentUserMessageId'
    const messageId = Storage?.getLocalStorageData(messageKeyForLocalStorage)
    let requestIdToCompare = store.getters.isResponseAnalyzerEnabled ? data?.requestPayload?.requestId?.toString() : data?.requestPayload?.messagePayload?.messageId?.toString()
    if (requestIdToCompare !== messageId?.toString() || store.state.fallbackMechanismState?.isVisible) {
      return
    }
    const customPayload = data.customPayload
    const chunkIndexValue = customPayload?.CHUNK_INDEX
    const statusValue = customPayload?.CHUNK_STATUS
    const dataWithCorrectChunkIndex = cloneDeep(data);
    dataWithCorrectChunkIndex.customPayload.CHUNK_INDEX -= this.fillerTextIndex
    this.chunksArray[chunkIndexValue - this.fillerTextIndex] = this.removeAudioAttachments(dataWithCorrectChunkIndex)
    if (statusValue === 'SUCCESS') {
      this.success = true
    }
    this.processChunks(dataWithCorrectChunkIndex)
  }

  removeAudioAttachments(data) {
    const audioAttachments = [];
    data.attachments = data.attachments.filter((attachment) => {
      if(componentMapper[attachment.type]?.[0] === 'AudioResponse') {
        audioAttachments.push(attachment);
        return false; 
      }
      return true; 
    });
    if(audioAttachments.length > 0) {
      this.audioAttachmentFound = true;
    }
    this.playAudioAttachments(audioAttachments);
    return cloneDeep(data)
  }


  playAudioAttachments(audioAttachments) {
    if(!store.state.isVoiceModeActive || audioAttachments.length === 0) return;
    const audioAttachment = audioAttachments[0];
    const audioText = audioAttachment.attachment.text;
    this.audioAttachment = audioText;
  }

  processChunks(data) {
    const startIndex = this.currentProcessingRequiredIndex
    const endIndex = this.chunksArray.length
    for (let i = startIndex; i < endIndex; i++) {
      if (this.chunksArray[i]) {
        store.dispatch('throttleFallbackMechanism', {
          userMessage: {
            payload: data.requestPayload?.messagePayload?.text,
            label: data.requestPayload?.messagePayload?.text,
            hideMessage: true,
            isStreaming: true
          },
          timestamp: data.requestPayload?.messagePayload?.timestamp
        })
        this.processChunk(this.chunksArray[i], i)
        this.currentProcessingRequiredIndex++
      } else {
        break
      }
    }
  }

  processChunk(data, index) {
    this.addStreamingInAnswerAiAttachment(data)
    if (index === 0) {
      const botResponse = botResponseMessageParser(data, false, false)
      const messages = cloneDeep(botResponse.messages)
      if (messages.length > 0) {
        if(store.getters.isStreamingEnabled && store.getters.disableInputFieldWhileStreaming) {
          store.dispatch('updateInputFieldStreamingDisableStatus', true)
        }
        if(store.getters.disableInputFieldOnSendMessage) {
          store.dispatch('updateInputFieldOnSendMessage', true)
        }
        const answerAiResponses = this.getAnswerAiResponses(data)
        answerAiResponses.forEach((answerAiResponse,answerAiResponseIndex)=>{
          if (answerAiResponse?.attachment?.type === 'ai.msg.domain.responses.core.Text') {
            const messageText = answerAiResponse?.attachment?.text
            const messageChunks = getDataInChunks(messageText, this.chunkLength)
            for (let messageChunkIndex = 0; messageChunkIndex < messageChunks.length; messageChunkIndex++) {
              if(messageChunkIndex === 0 && answerAiResponseIndex === 0){
                const dummyAnswerAiResponse = cloneDeep(answerAiResponse)
                dummyAnswerAiResponse.attachment.text = messageChunks[messageChunkIndex];
                dummyAnswerAiResponse.attachment.type = componentMapper[answerAiResponse?.attachment.type][0]
                const dummyData = cloneDeep(data);
                dummyData.attachments = [dummyAnswerAiResponse];
                store.dispatch('processChunkResponse', dummyData)
                this.lastChunkProcessed  = dummyAnswerAiResponse
              }
              else if(messageChunks[messageChunkIndex]) {
                const chunk = this.createTextChunk(messageChunks, messageChunkIndex, answerAiResponse, answerAiResponses, answerAiResponseIndex, data )
                this.chunkQueue.push({ chunk, index: this.totalChunks })
                this.totalChunks++
              }
              if(messageChunks?.length === 1 && data?.customPayload?.IS_TEXT_BUBBLE_COMPLETED) {
                this.startNewMessage = true
              }
              this.processChunksQueue()
            }
          } else if (componentMapper[answerAiResponse?.attachment?.type][0]) {
            if(answerAiResponseIndex === 0 ) {
              const dummyData = cloneDeep(data);
              dummyData.attachments = [answerAiResponse];
              store.dispatch('processChunkResponse', dummyData)
              answerAiResponse.attachment.type = componentMapper[answerAiResponse?.attachment.type][0]
              this.lastChunkProcessed  = answerAiResponse
            } else {
              const chunk = this.createNonTextChunk(answerAiResponse,data)
            this.chunkQueue.push({ chunk, index: this.totalChunks })
            this.totalChunks++
            this.processChunksQueue()
          }
          }
        }) 
      }
    } else {
      const answerAiResponses = this.getAnswerAiResponses(data)
      answerAiResponses.forEach((answerAiResponse, answerAiResponseIndex)=>{
        if (answerAiResponse?.attachment?.type === 'ai.msg.domain.responses.core.Text') {
          const messageText = answerAiResponse?.attachment?.text
          const messageChunks = getDataInChunks(messageText, this.chunkLength)
          for (let messageChunkIndex = 0; messageChunkIndex < messageChunks.length; messageChunkIndex++) {  
            const chunk = this.createTextChunk(messageChunks, messageChunkIndex, answerAiResponse, answerAiResponses, answerAiResponseIndex, data)
            this.chunkQueue.push({ chunk, index: this.totalChunks })
            this.totalChunks++
            this.processChunksQueue()
          }
        } else if (componentMapper[answerAiResponse?.attachment.type][0] && !this.isLastChunk()) {
            const chunk = this.createNonTextChunk(answerAiResponse, data)
            this.chunkQueue.push({ chunk, index: this.totalChunks })
            this.totalChunks++
            this.processChunksQueue()
          }
        this.processChunksQueue()
      })
    }
    if (this.isLastChunk()) {
      this.processLastChunk()
      store.getters.isPromptTestingEnable && emitEventToParentWindow(eventType.RESPONSE_RECEIVED,{conversationId: data?.requestPayload?.conversationId, messageId:data?.requestPayload?.messagePayload?.messageId, requestId: data?.requestPayload?.requestId, userQuery: data?.requestPayload?.messagePayload?.label})
    }
  }

  processLastChunk() {
    const attachments = this.chunksArray?.[this.chunksArray?.length-1]?.attachments
    const answerAiTextAttachments = this.chunksArray?.[this.chunksArray?.length-1]?.attachments?.filter(
      attachment => 
        (attachment?.attachment?.attachmentResponseType === 'ANSWER_AI_RESPONSE' && attachment.type === 'ai.msg.domain.responses.core.Text')
    )
    answerAiTextAttachments?.forEach(attachment=>{
      attachment.attachment.text = ""
    })
    const data = {}
    this.combineCarouselAttachment(attachments)
    data.attachments = attachments
    const botResponse = botResponseMessageParser(data, true, false)
    const messages = cloneDeep(botResponse?.messages)
    const delay = CONSTANTS.STREAM_TIME_FOR_EACH_CHUNK * this.totalChunks + CONSTANTS.STREAM_TIME_FOR_EACH_CHUNK
    const dummyAnswerAiAttachment = this.chunksArray
      .find(chunk =>
        chunk?.attachments?.some(attachment =>
          attachment?.attachment?.attachmentResponseType === 'ANSWER_AI_RESPONSE'
        )
      )?.attachments
      ?.find(attachment =>
        attachment?.attachment?.attachmentResponseType === 'ANSWER_AI_RESPONSE'
      )
    if (dummyAnswerAiAttachment) {
      const timeoutId = setTimeout(() => {
        store.dispatch('removeStreamingFromAttachment', dummyAnswerAiAttachment)
      },delay)
      this.timerIds.push(timeoutId)
    }
    if (messages.length > 0) {
      const id = setTimeout(() => {
        const isReviewEnabled = messages.find(message => message.type === 'TextResponse' &&  message?.messageValue?.isReviewEnabled)
        if (isReviewEnabled) {
          store.dispatch('addFeedbackforLastAttachment')
        }
        messages.forEach(message => {
          store.dispatch('updateMessageInLastChat', message)
        })
      }, delay)
      this.timerIds.push(id)
    }
    const quickReplyMessages = messages.filter((message)=>message.messageValue.quickReply)
    store.dispatch('processQuickReplies', {delay, messages:quickReplyMessages, timerIds:[]})
    const id = setTimeout(() => {
      this.endChunkProcessing()
    }, delay)
    this.timerIds.push(id)
  }

  processChunksQueue () {
    if (this.chunkQueue.length === 0) return
    const { chunk } = this.chunkQueue.shift()
    const customPayload = cloneDeep(chunk.customPayload)
    if(chunk.customPayload) {
      delete chunk.customPayload
    }
    const delay = this.getTotalDelay()
    if(this.isTypeTextResponse(this.lastChunkProcessed) && this.isTypeTextResponse(chunk) && !this.startNewMessage) {
      const id = setTimeout(() => {
        store.commit('UPDATE_LAST_CHUNK_MESSAGE_V2', chunk)
        this.processChunksQueue()
      }, delay)
      this.timerIds.push(id)
    } else if (this.isTypeCarouselResponse(this.lastChunkProcessed) && this.isTypeCarouselResponse(chunk)){
      const id = setTimeout(() => {
        store.commit('UPDATE_LAST_CHUNK_CAROUSEL_MESSAGE', chunk)
        this.processChunksQueue()
      }, delay)
      this.timerIds.push(id)
    } else {
      const id = setTimeout(() => {
        store.dispatch('updateMessageInLastChat', chunk)
        this.processChunksQueue()
      }, delay)
      this.timerIds.push(id)
    }
    this.startNewMessage = false
    if(customPayload?.IS_TEXT_BUBBLE_COMPLETED) {
      this.startNewMessage = true
    }
    this.lastChunkProcessed = chunk
  }

  endChunkProcessing(disableInputFieldOnSendMessage) {
    if(!disableInputFieldOnSendMessage) {
      store.dispatch('updateInputFieldOnSendMessage', false)
    }
    this.fillerTextIndex = 0
    store.commit("UPDATE_PROGRESSIVE_TYPING_INDICATOR_CONFIG")
    this.chunkQueue = []
    this.chunkLength = 3
    this.totalChunks = 0
    this.chunksArray = []
    this.currentProcessingRequiredIndex = 0
    this.success = false
    clearAllSetTimeout(this.timerIds)
    this.timerIds = []
    this.lastChunkProcessed = null
    this.startNewMessage = false
    store.dispatch('updateInputFieldStreamingDisableStatus', false)
    store.dispatch('clearFallbackMechanismTimer')
    const messageKeyForLocalStorage = store.getters.isResponseAnalyzerEnabled ? 'responseAnalyzerMessageId' : 'currentUserMessageId'
    Storage.removeLocalStorageData(messageKeyForLocalStorage)
    if(store.state.isVoiceModeActive) {
      // End-chunk processing is called when 1. chunks are processed 2. when a new message is sent. Because of this, the older message is read again when 
      // a new message is sent, therefore, added a check of disableInputFieldOnSendMessage which is sent as true when sending a new message. 
      if(!disableInputFieldOnSendMessage && this.audioAttachment && store.getters.textToSpeechOrationResponse) {
        TextAccumulatorUtil.init()
        TextAccumulatorUtil.accumulateText(this.audioAttachment,false)
      }
      TextAccumulatorUtil.playLastChunk()
    }
  }

  createTextChunk(messageChunks, messageChunkIndex, answerAiResponse, answerAiResponses, answerAiResponseIndex, data) {
    const chunk =  {
      messageId: uuidV4(),
      requestId: data.requestId,
      hide: hideMessage(
        answerAiResponse,
        componentMapper[answerAiResponse.type][0],
        false
      ),
      type: componentMapper[answerAiResponse.type][0],
      messageValue: cloneDeep(answerAiResponse.attachment),
      timestamp: parseInt(data.timestamp),
      isUser: false,
      ...(messageChunkIndex === messageChunks.length-1 && answerAiResponseIndex === answerAiResponses.length-1 && {customPayload: cloneDeep(data.customPayload)}),
      attachment: {
        text: messageChunks[messageChunkIndex],
        type: componentMapper[answerAiResponse?.attachment.type][0],
        timestamp: parseInt(data.timestamp)
      }
    }
    chunk.messageValue.text = messageChunks[messageChunkIndex]
    return chunk
  }

  createNonTextChunk(answerAiResponse,data) {
    const chunk =  {
      messageId: uuidV4(),
      requestId: data.requestId,
      type: componentMapper[answerAiResponse.type][0],
      hide: hideMessage(
        answerAiResponse,
        componentMapper[answerAiResponse.type][0],
        false
      ),
      messageValue: cloneDeep(answerAiResponse.attachment),
      timestamp: parseInt(data.timestamp),
      isUser: false,
      attachment: {
        type: componentMapper[answerAiResponse?.attachment.type][0],
        timestamp: parseInt(data.timestamp)
      }
    }
    return chunk
  }

  addStreamingInAnswerAiAttachment(data) {
    const answerAiResponses = this.getAnswerAiResponses(data)
    answerAiResponses.forEach((answerAiResponse)=>{
      if (answerAiResponse.attachment) {
        answerAiResponse.attachment.isStreaming = true
        answerAiResponse.attachment.isPartialStreaming = true
      }
    })
  }

  getAnswerAiResponses(data) {
    return data?.attachments?.filter(attachment =>
      attachment?.attachment?.attachmentResponseType === 'ANSWER_AI_RESPONSE'
    );
  }

  addTimerIds(id) {
    this.timerIds.push(id)
  }

  getTotalDelay() {
    return CONSTANTS.STREAM_TIME_FOR_EACH_CHUNK * this.totalChunks
  }

  isLastChunk() {
    return this.success && this.currentProcessingRequiredIndex === this.chunksArray.length - 1
  }

  isTypeTextResponse(message) {
    return message?.attachment?.type === 'TextResponse' || false
  }

  isTypeCarouselResponse(message) {
    return message?.attachment?.type === 'CarouselResponse' || false
  }

  combineCarouselAttachment(attachments) {
    if (!Array.isArray(attachments)) return

    const carousels = attachments.filter(att => att.type === "ai.msg.domain.responses.core.Carousel")
    if (carousels.length === 0) return

    const combinedElements = []
    for (const c of carousels) {
      if (c.attachment && Array.isArray(c.attachment.elements)) {
        for (const el of c.attachment.elements) {
          combinedElements.push(el)
        }
      }
    }

    const combinedCarousel = carousels[0]
    combinedCarousel.attachment.elements = combinedElements

    const firstCarouselIndex = attachments.findIndex(att => att.type === "ai.msg.domain.responses.core.Carousel")

    for (let i = attachments.length - 1; i >= 0; i--) {
      if (attachments[i].type === "ai.msg.domain.responses.core.Carousel") {
        attachments.splice(i, 1)
      }
    }

    attachments.splice(firstCarouselIndex, 0, combinedCarousel)
  }
}

export default new StreamHandler()
